import { actionTextColor } from "../utils/themeContrast";
import React, { useState, useEffect, useRef } from "react";

import { Link, navigate } from "@reach/router";
import styled from "@emotion/styled";

import useWindowDimensions from "../hooks/useWindowDimensions";
import axios from "axios";
import moment from 'moment';
import Modal from "../newcomponents/optioncomponents/Modal";
import TakeAwayModal from '../newcomponents/optioncomponents/TakeAwayModal';
import { IoIosArrowBack } from "react-icons/io";
import promo from '../newcomponents/customerComponents/Promotion';
import { UserContext, ActionContext, ThemeContext, LanguageContext } from "../contexts/Context";
import AdvocadoLogin from '../newcomponents/advocadoComponents/AdvocadoLogin';
import TableInfo from '../newcomponents/CheckOutInfo/TableInfo';
import ReserveInfo from "../newcomponents/CheckOutInfo/ReserveInfo";
import OrderLoading from "../newcomponents/OrderLoading";
import PickupInfo from "../newcomponents/CheckOutInfo/PickupInfo";
import DeliveryInfo from "../newcomponents/CheckOutInfo/DeliveryInfo";
import { IoGift, IoTrashBinOutline } from "react-icons/io5";
import { TbDiscount2 } from 'react-icons/tb';
import AdvocadoRedeem from '../newcomponents/advocadoComponents/AdvocadoRedeem';
import VoucherField from '../newcomponents/customerComponents/VoucherField';
import CustomerLogin from '../newcomponents/customerComponents/CustomerLogin';
import CustomerRedeem from '../newcomponents/customerComponents/CustomerRedeem';
import GHL from '../newcomponents/GHLMethod';
import { lightTint, readableText } from "../utils/themeContrast";
import { OrderIdentity } from "../newcomponents/OrderReceipt";
import { getUnavailableCartItems } from "../utils/menuAvailability";
import { getCheckoutPricing, getOrderContact, mergePendingOrder, readPendingContext, readStoredJSON, savePendingOrder } from '../utils/pendingOrder';
// import redeem from '../screens/redeem';
const Checkout = () => {
  //component ref
  const orderRef = useRef(null);
  const asiaPaySubmit = useRef(null);
  const ghlSubmit = useRef(null);
  const debiaSubmit = useRef(null);
  const [showAdvocadoLogin, setShowAdvocadoLogin] = useState(false);
  const [showMemberLogin, setShowMemberLogin] = useState(false);

  const [show, setShow] = useState(false); //warning dialog
  const [showDialog, setDialog] = useState(false); //display dialog to show advocado Redeem Dialog

  const [showTk, setShowTk] = useState(false); //display dialog to input cusomter detail
  const [restored, setRestored] = useState(false);
  const didRestore = useRef(false);
  //0 is TakeAway  1 is Dine in
  const [deliveryType, setDeliveryType] = useState(0); //user select delivery or pickup or dinein
  const [deliveryPrice, setDeliveryPrice] = useState(0); //display delivery | pickup option
  const [error, setError] = useState([]);

  const { height, width } = useWindowDimensions();
  const [signature, setSignature] = useState("");
  const [merchantCode, setMerchantCode] = useState("");
  const [debiaFormData, setDebiaFormData] = useState(null);
  //State
  // const [arrayBarState, setArrayBarState] = useState([
  //   { itemOptionId: 0, title: "Cart", title2: "菜单", active: true, menuTitle: "CURRENT ORDER", menuTitle2: "当前订单" },
  //   { itemOptionId: 1, title: "Review Order", title2: "查看已下订单", active: false, menuTitle: "REVIEW ORDER HISTORY", menuTitle2: "查看已下订单" },
  // ]);
  const [isLoading, setLoading] = useState(false);
  //Context
  const {
    cart,
    token,
    userId,
    orderTime,
    company,
    tax,
    paymentData,
    isTakeAway,
    hasPayment,
    paymentPlatform,
    isDemo,
    lanIndex,
    isLanReverse,
    currencySymbol,
    allowTAafterWH,
    startTime,
    endTime,
    otherUrls,
    hasAdvocado,
    advocadoRedeem,
    finalOrder,
    isOnlinePayMinConsumption,
    onlinePayMinConsumptionVal,
    discount,
    redeem,
    adCustomer,
    customer,
    hasVoucher,
    pm,
    isAdvocadoPayment,
    memberRedeem,
    hasMember,
    payType,
    additionalPickUpTime,
    takeAwayInfo,
    vouchers,
    isLoad
  } = React.useContext(UserContext);

  const { clearCart, addToCart, setReserveData, setFinalOrder, setRedeem, setDiscount, addVoucher, addPromotion, addTakeAwayInfo, addCustomer, addAdCustomer, addPayType, payByAdvocado } = React.useContext(ActionContext);
  const { ready: pricingReady, serviceCharge, finalAmount } = getCheckoutPricing(
    cart, discount, tax, paymentData, isTakeAway, deliveryType
  );
  const bcrsNo = promo.getBCRSNo(cart, isTakeAway, deliveryType);
  const canSubmit = restored && isLoad !== false && !!token && userId != null &&
    String(userId) === String(finalOrder?.userId) && pricingReady && Number.isFinite(deliveryPrice) &&
    Number.isFinite(finalAmount + deliveryPrice);

  const themeContext = React.useContext(ThemeContext);
  const language = React.useContext(LanguageContext);

  useEffect(() => {
    const restoreAfterBack = event => {
      if (event.persisted) setLoading(false);
    };
    window.addEventListener('pageshow', restoreAfterBack);
    return () => window.removeEventListener('pageshow', restoreAfterBack);
  }, []);

  useEffect(() => {
    // App restores session-level customer/voucher defaults in its mount effect.
    // Wait for that batch before restoring the authoritative pending checkout.
    if (isLoad === false || didRestore.current) return;
    didRestore.current = true;
    const savedOrder = readStoredJSON("finalOrder");
    const pendingContext = readPendingContext();
    const restoredOrder = savedOrder && { ...getOrderContact({}, pendingContext?.takeAwayInfo || takeAwayInfo), ...savedOrder };

    if (restoredOrder && Array.isArray(restoredOrder.data) && restoredOrder.data.length > 0) {
      const finalOrder = restoredOrder;
      setFinalOrder(finalOrder);
      addVoucher(finalOrder.vouchers || []);
      setDeliveryType(Number(finalOrder.deliveryType ?? 0));
      addTakeAwayInfo({ ...takeAwayInfo, ...getOrderContact(finalOrder) });
      if (finalOrder.customer !== undefined) addCustomer(finalOrder.customer);
      if (finalOrder.adCustomer !== undefined) addAdCustomer(finalOrder.adCustomer);
      if (pendingContext?.payType !== undefined) addPayType(pendingContext.payType);
      if (pendingContext?.isAdvocadoPayment !== undefined) payByAdvocado(pendingContext.isAdvocadoPayment);

      setDeliveryPrice(Number(finalOrder.deliveryPrice || 0));
      setRedeem(finalOrder.redeem || []);
      setDiscount(finalOrder.discount || null);
      setSubtotal(promo.subTotalAmount(finalOrder.data, finalOrder.discount));
      setDefaultAmount(promo.subTotalDefaultAmount(finalOrder.data))
      addToCart(finalOrder.data);
    } else if (finalOrder) {
      setDeliveryType(Number(finalOrder.deliveryType ?? 0));
      setDeliveryPrice(Number(finalOrder.deliveryPrice || 0));
    }
    setRestored(true);
  }, [setFinalOrder, isLoad]);

  // Keep edits made on this screen recoverable even before the payment button is pressed.
  useEffect(() => {
    if (!restored || !finalOrder?.orderId || !cart.length) return;
    try {
      savePendingOrder(mergePendingOrder(finalOrder, { data: cart, customer, adCustomer,
        vouchers, discount, redeem, deliveryType, deliveryPrice }), takeAwayInfo, { payType, isAdvocadoPayment });
    } catch {
      // Submission reports storage errors; browsing the summary must remain possible.
    }
  }, [restored, finalOrder, cart, customer, adCustomer, vouchers, discount, redeem,
    deliveryType, deliveryPrice, takeAwayInfo, payType, isAdvocadoPayment]);

  useEffect(() => {
    let shouldRedirect = localStorage.getItem("shouldRedirect");

    //if dont have advocado redemption, skip this screen
    if (canSubmit && !memberRedeem && !advocadoRedeem && cart.length != 0 && paymentPlatform != 0 && shouldRedirect == "YES" && finalOrder != null && Array.isArray(finalOrder.data) && finalOrder.data.length > 0) {
      localStorage.setItem("shouldRedirect", "NO");
      sendOrder();
    }
  }, [cart, paymentPlatform, advocadoRedeem, memberRedeem, finalOrder, canSubmit, finalAmount]);

  useEffect(() => {
    let checkinTime = localStorage.getItem("checkIn");
    if (checkinTime) {
      let diff = (new Date().getTime() - checkinTime) / 1000 / 60 / 60;

      if (diff > 1) {
        window.location.replace(otherUrls && otherUrls.length > 0 ? otherUrls[0].url : "https://google.com");
      }
    }

    if (isTakeAway && !allowTAafterWH) {
      let stime = moment(startTime);
      let etime = moment(endTime);
      let tdyTxt = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
      let day = new Date().getDay();
      let st = moment().set("hour", stime.get("hour")).set("minute", stime.get("minute"));
      let et = moment().set("hour", etime.get("hour")).set("minute", etime.get("minute"));
      if (stime.get("hour") < etime.get('hour')) {
        et = et.add(24, "hour");
      }
      if (moment().isBefore(st) || moment().isAfter(et)) {
        let isMatch = false;
        for (let pk of additionalPickUpTime) {
          if (pk.weekDays && pk.weekDays.indexOf(tdyTxt[day]) > -1) {
            stime = moment(pk.startTime);
            etime = moment(pk.endTime);
            st = moment().set("hour", stime.get("hour")).set("minute", stime.get("minute"));
            et = moment().set("hour", etime.get("hour")).set("minute", etime.get("minute"));

            if (moment().isAfter(st) && moment().isBefore(et)) {
              isMatch = true;
              break;
            }
          }
        }
        if (!isMatch)
          window.location.replace(otherUrls && otherUrls.length > 0 ? otherUrls[0].url : "https://google.com");
      }
    }
  }, [isTakeAway, paymentData]);

  const [subtotal, setSubtotal] = useState(promo.subTotalAmount(cart));
  const [defaulAmount, setDefaultAmount] = useState(promo.subTotalDefaultAmount(cart));


  const notAllowToCheck = () => {
    setError([{
      errorElement: "No Item Selected",
      errorMessage: (
        <b style={{ color: "#CF000D" }}>{language[lanIndex].pleaseSelectItem}</b>
      )
    }])
    setShow(true);
  }

  const getItemTitle = (item) => {
    return (lanIndex == 0 && !isLanReverse) || (lanIndex == 1 && isLanReverse) ?
      item.title :
      (item.title2 ? item.title2 : item.title);
  };

  const validateCartAvailability = (scheduleTime, orderItems = cart) => {
    const unavailableItems = getUnavailableCartItems(orderItems, scheduleTime);
    if (unavailableItems.length == 0) return true;

    setError([{
      errorElement: "Item unavailable",
      errorMessage: (
        <b style={{ color: "#CF000D" }}>
          {`Some items are not available at ${moment(scheduleTime).format("DD/MM HH:mm")}: ${unavailableItems.map(getItemTitle).join(", ")}`}
        </b>
      )
    }]);
    setShow(true);
    return false;
  };

  const sendOrder = async () => {
    if (!canSubmit) return;
    //check if demo
    if (isDemo) return;
    //check if has item
    if (cart.length == 0) {
      notAllowToCheck();
      return;
    }

    if (isTakeAway) { //TakeAway
      if (hasPayment) { //check if has exceed min. spending amt
        if (isOnlinePayMinConsumption && subtotal < onlinePayMinConsumptionVal) {
          setError([{
            errorElement: language[lanIndex].belowMinSpendning,
            errorMessage: (
              <b style={{ color: "#CF000D" }}>{language[lanIndex].belowMinSpending2}<br />
                {language[lanIndex].belowMinSpending3 + " " + currencySymbol + onlinePayMinConsumptionVal.toFixed(2)}</b>
            )
          }])
          setShow(true);
          return;
        }
      }
    }
    if (!validateCartAvailability(finalOrder && finalOrder.scheduleTime, finalOrder && finalOrder.data ? finalOrder.data : cart)) return;
    sendOrderToPayment(finalOrder);
  }

  //takeaway checkout after confirm delivery
  const confirmTKCheckOut = async (customerName, phone, scheduleTime, address, remark, checkbox, deliveryType, roomNo, postal, unit, addressLine) => {
    if (!validateCartAvailability(scheduleTime, finalOrder && finalOrder.data ? finalOrder.data : cart)) return;
    finalOrder.customerName = customerName;
    finalOrder.phone = phone;
    finalOrder.scheduleTime = scheduleTime;
    finalOrder.address = address;
    if (postal !== undefined) finalOrder.postal = postal;
    if (unit !== undefined) finalOrder.unit = unit;
    if (addressLine !== undefined) finalOrder.addressLine = addressLine;
    finalOrder.remark = remark;
    finalOrder.roomNo = roomNo;
    finalOrder.checkbox = checkbox;
    finalOrder.deliveryType = deliveryType;

    takeAwayInfo.customerName = customerName;
    takeAwayInfo.phone = phone;
    takeAwayInfo.scheduleTime = scheduleTime;
    takeAwayInfo.address = address;
    if (postal !== undefined) takeAwayInfo.postal = postal;
    if (unit !== undefined) takeAwayInfo.unit = unit;
    if (addressLine !== undefined) takeAwayInfo.addressLine = addressLine;
    takeAwayInfo.remark = remark;
    takeAwayInfo.checkbox = checkbox;
    takeAwayInfo.deliveryType = deliveryType;
    takeAwayInfo.roomNo = roomNo;
    takeAwayInfo.saveTime = new Date().getTime();
    addTakeAwayInfo(takeAwayInfo);
    setDeliveryType(Number(deliveryType));
    setFinalOrder({ ...finalOrder });
    savePendingOrder(finalOrder, takeAwayInfo, { payType, isAdvocadoPayment });
  }

  const sendAsAdvocadoCredit = async (order) => {
    await axios.post("/v2/api/advocado/storeCredit", order, { timeout: 30000, headers: { Authorization: "Bearer " + token } })
      .then(function (response) {
        // handle success
        localStorage.setItem("orderId", order.orderId);
        clearCart();
        setLoading(false);
        let newPromo = pm;
        newPromo = newPromo.filter((p) => !p.isVoucher);
        addPromotion(newPromo);
        //push to success page
        navigate('/payment/success');
      })
      .catch(function (response) {
        // handle error
        navigate('/order/fail');

      });
  }

  //redirect to online payment
  const sendOrderToPayment = async (order) => {
    if (!canSubmit) return;
    try {
      // Login and rewards on this screen can change the checkout snapshot.
      order = mergePendingOrder(order, { customer, adCustomer, vouchers, data: cart, discount, redeem, deliveryPrice, deliveryType });
      if (!order.orderId || !order.data.length) return;
      savePendingOrder(order, takeAwayInfo, { payType, isAdvocadoPayment });
      localStorage.setItem('shouldRedirect', 'NO');

      setLoading(true);
      if (order && order.scheduleTime && !validateCartAvailability(order.scheduleTime, order.data ? order.data : cart)) {
        setLoading(false);
        return;
      }

      if (isAdvocadoPayment) {
        await sendAsAdvocadoCredit(order);
        return;
      }
      if (finalAmount + deliveryPrice == 0) {
        await axios.post("/v2/api/selfOrder/order", order, { timeout: 30000, headers: { Authorization: "Bearer " + token } })
          .then(async function (response) {
            await axios.get(`/v2/api/selfOrder/order?userId=${userId}&orderTime=${orderTime}&orderId=${order.orderId}`,
              { timeout: 30000, headers: { Authorization: "Bearer " + token } }
            );
          })
          .then(function (response) {
            // handle success
            localStorage.setItem("orderId", order.orderId);
            clearCart();
            setLoading(false);
            let newPromo = pm;
            newPromo = newPromo.filter((p) => !p.isVoucher);
            newPromo = newPromo.filter((p) => !p.customerRewardId);
            addPromotion(newPromo);
            //push to success page
            navigate('/payment/success');
          })
          .catch(function (response) {
            // handle error
            navigate('/order/fail');

          });

      } else {
        //store pending order
        await axios.post('/v2/api/selfOrder/onlinePayment', order, { timeout: 30000, headers: { Authorization: "Bearer " + token } });
        orderRef.current.value = order.orderId;
        localStorage.setItem("orderId", order.orderId);
        // localStorage.setItem("order", JSON.stringify(cart));
        let amount = (finalAmount + order.deliveryPrice).toFixed(2);


        if (paymentPlatform == 0 && payType != 3) { //asiapay
          asiaPaySubmit.current.click();
        } else if (paymentPlatform == 1 && payType != 3) { //hitpay
          let response = await axios.post('/v2/api/hitpay', { amount: amount, orderId: order.orderId }, { timeout: 30000, headers: { Authorization: "Bearer " + token } });
          if (!response.data?.url) throw new Error('Missing payment URL');
          if (response.status !== 200) throw new Error('Payment request failed');
          if (response.status == 200) {
            setTimeout(function () { window.location.assign(response.data.url); }, 250);
            // Retain pending checkout until the success response is confirmed.
          }
        } else if (paymentPlatform == 2 && payType != 3) {
          let response = await axios.post('/v2/api/pocketPay', { amount: amount, orderId: order.orderId }, { timeout: 30000, headers: { Authorization: "Bearer " + token } });
          if (!response.data?.url) throw new Error('Missing payment URL');
          if (response.status !== 200) throw new Error('Payment request failed');
          if (response.status == 200) {
            setTimeout(function () { window.location.assign(response.data.url); }, 250);
            // Retain pending checkout until the success response is confirmed.
          }
        } else if (paymentPlatform == 3 && payType != 3) {//qulb payment
          let response = await axios.post('/v2/api/qlubPay', { amount: amount, orderId: order.orderId }, { timeout: 30000, headers: { Authorization: "Bearer " + token } });
          if (!response.data?.url) throw new Error('Missing payment URL');
          if (response.status !== 200) throw new Error('Payment request failed');
          if (response.status == 200) {
            let toF = setTimeout(function () {

              window.location.replace(response.data.url);
              //retry second time
              setTimeout(
                function () {

                  window.location.replace(response.data.url);
                  clearTimeout(this);

                }
                , 3000);

              clearTimeout(this);
            }, 250);

            // Retain pending checkout until the success response is confirmed.

          }
        } else if (paymentPlatform == 4 && payType != 3) { //smooch pay
          let response = await axios.post('/v2/api/smoochPay', { amount: amount, orderId: order.orderId }, { timeout: 30000, headers: { Authorization: "Bearer " + token } });
          if (!response.data?.url) throw new Error('Missing payment URL');
          if (response.status !== 200) throw new Error('Payment request failed');
          if (response.status == 200) {
            let toF = setTimeout(function () {

              window.location.replace(response.data.url);
              //retry second time
              setTimeout(
                function () {

                  window.location.replace(response.data.url);
                  clearTimeout(this);

                }
                , 3000);

              clearTimeout(this);
            }, 250);

            // Retain pending checkout until the success response is confirmed.

          }
        } else if (paymentPlatform == 5 || payType == 3) {//fomo
          let response = await axios.post('/v2/api/fomo', { amount: amount, orderId: order.orderId }, { timeout: 30000, headers: { Authorization: "Bearer " + token } });
          if (!response.data?.url) throw new Error('Missing payment URL');
          if (response.status !== 200) throw new Error('Payment request failed');
          if (response.status == 200) {
            setTimeout(function () {

              window.location.replace(response.data.url);
              //retry second time
              setTimeout(
                function () {

                  window.location.replace(response.data.url);
                  clearTimeout(this);

                }
                , 3000);

              clearTimeout(this);
            }, 250);

            // Retain pending checkout until the success response is confirmed.

          }
        } else if (paymentPlatform == 6) {//ghl
          let response = await GHL.generateRequestSignature(
            {
              refNo: finalOrder.orderId,
              amount,
              currency: "MYR",
              token
            }
          )
          setMerchantCode(response.merchantCode);
          setSignature(response.signature);
        } else if (paymentPlatform == 7) { //yeah pay
          let response = await axios.post('/v2/api/yeahpay', { amount: amount, orderId: order.orderId }, { timeout: 30000, headers: { Authorization: "Bearer " + token } });
          if (!response.data?.url) throw new Error('Missing payment URL');
          if (response.status !== 200) throw new Error('Payment request failed');
          if (response.status == 200) {
            setTimeout(function () {

              window.location.replace(response.data.url);
              //retry second time
              setTimeout(
                function () {

                  window.location.replace(response.data.url);
                  clearTimeout(this);
                }
                , 3000);

              clearTimeout(this);
            }, 250);

            // Retain pending checkout until the success response is confirmed.
          }
        } else if (paymentPlatform == 8) { //all in pay
          let response = await axios.post('/v2/api/allInPay', { amount: amount, orderId: order.orderId }, { timeout: 30000, headers: { Authorization: "Bearer " + token } });
          if (!response.data?.url) throw new Error('Missing payment URL');
          if (response.status !== 200) throw new Error('Payment request failed');
          if (response.status == 200) {
            setTimeout(function () {

              window.location.replace(response.data.url);
              //retry second time
              setTimeout(
                function () {

                  window.location.replace(response.data.url);
                  clearTimeout(this);
                }
                , 3000);

              clearTimeout(this);
            }, 250);

            // Retain pending checkout until the success response is confirmed.
          }
        } else if (paymentPlatform == 9) { //gkash
          let response = await axios.post('/v2/api/gkash', { amount: amount, orderId: order.orderId }, { timeout: 30000, headers: { Authorization: "Bearer " + token } });
          if (response.status !== 200) throw new Error('Payment request failed');
          if (response.status == 200) {
            // Retain pending checkout until the success response is confirmed.

            const data = response.data;
            document.open();
            document.write(data.html);
            document.close();
          }
        } else if (paymentPlatform == 10) { //debia
          let response = await axios.post('/v2/api/debia/online-banking/signature', { amount: amount, orderId: order.orderId }, { timeout: 30000, headers: { Authorization: "Bearer " + token } });
          if (response.status !== 200) throw new Error('Payment request failed');
          if (response.status == 200) {
            setDebiaFormData(response.data);
          }
        } else if (paymentPlatform == 11) {
          let response = await axios.post('/v2/api/airwallex', { amount: amount, orderId: order.orderId }, { timeout: 30000, headers: { Authorization: "Bearer " + token } });
          if (!response.data?.url) throw new Error('Missing payment URL');
          if (response.status !== 200) throw new Error('Payment request failed');
          if (response.status == 200) {
            setTimeout(function () {

              window.location.replace(response.data.url);
              //retry second time
              setTimeout(
                function () {

                  window.location.replace(response.data.url);
                  clearTimeout(this);
                }
                , 3000);

              clearTimeout(this);
            }, 250);

            // Retain pending checkout until the success response is confirmed.
          }
        } else {
          throw new Error('Payment method unavailable');
        }
      }
    } catch (error) {
      setLoading(false);
      setError([{ errorMessage: 'Unable to start payment. Your order has been kept. Please try again.' }]);
      setShow(true);
    }
  }

  const handleRewardRemove = (r, i) => () => {
    if (advocadoRedeem) {
      handleAdvRewardRemove(r, i);
    } else {
      handleCusRewardRemove(r, i);
    }
  }
  const handleBackToCheckout = () => {
    let newCart = JSON.parse(JSON.stringify(cart)).filter((item) => !item.autoAddedReward);
    let newPromo = pm ? JSON.parse(JSON.stringify(pm)) : [];

    for (let item of newCart) {
      item.hasSpecialDiscount = false;
      item.specialDiscount = 0;
      item.specialDiscountAmount = 0;
      item.specialDiscountRemark = "";
    }

    newPromo = newPromo.filter((promotion) => !promotion.customerRewardId);
    newCart = promo.clearPromotion(newCart);
    newCart = promo.applyPromotion(newPromo, newCart);

    let newFinalOrder = Object.assign({}, finalOrder, {
      data: newCart,
      discount: null,
      redeem: []
    });

    setRedeem([]);
    setDiscount(null);
    addPromotion(newPromo);
    addToCart(newCart);
    setFinalOrder(newFinalOrder);
    localStorage.setItem("order", JSON.stringify(newCart));
    localStorage.setItem("finalOrder", JSON.stringify(newFinalOrder));
    navigate('/checkout');
  }
  const handleCusRewardRemove = (r, i) => {
    let newCart = JSON.parse(JSON.stringify(cart));
    if (redeem[i].rewardId == r.rewardId) {
      redeem.splice(i, 1);
      if (r.discountType == 4) {
        let pms = JSON.parse(JSON.stringify(pm));
        pms = pms.filter(p => p.customerRewardId != r.rewardId);

        localStorage.setItem("promotion", JSON.stringify(pms));
        addPromotion(pms);
        newCart = promo.clearPromotion(newCart);
        newCart = promo.applyPromotion(pms, newCart);
        setSubtotal(promo.subTotalAmount(newCart, discount));

      } else if (r.discountType == 0) {
        if (discount && discount.furtherDiscount > 0) {
          discount.furtherDiscount = 0;
          discount.hasFurtherDiscount = false;
          discount.furtherDiscountRemark = "";
        } else if (discount) {
          let discountAmt = 0;
          if (discount.isAfterTax) {
            discountAmt = r.discountPrice / (1 + tax.tax);
          } else {
            discountAmt = r.discountPrice;
          }
          discount.furtherDiscountAmount -= discountAmt;
          if (discount.furtherDiscountAmount < 0) {
            discount.furtherDiscountAmount = 0;
          }
          discount.hasFurtherDiscount = Math.round(discount.furtherDiscountAmount * 100) > 0;
          if (!discount.hasFurtherDiscount) {
            discount.furtherDiscountRemark = "";
          }
        }
        setDiscount(discount);
        setSubtotal(promo.subTotalAmount(newCart, discount));
      } else {
        if (newCart[r.index].autoAddedReward) {
          newCart.splice(r.index, 1);
          redeem.forEach((entry) => {
            if (entry.index > r.index) entry.index -= 1;
          });
        } else if (newCart[r.index].specialDiscount > 0) {
          newCart[r.index].specialDiscount = 0;
          newCart[r.index].hasSpecialDiscount = false;
          newCart[r.index].specialDiscountRemark = "";
          newCart[r.index].specialDiscountAmount = 0;
        } else {
          newCart[r.index].specialDiscountAmount -= r.discountPrice;
          newCart[r.index].specialDiscount = 0;
          newCart[r.index].hasSpecialDiscount = false;
          newCart[r.index].hasSpecialDiscount = Math.round(newCart[r.index].specialDiscountAmount * 100) > 0;
          if (!newCart[r.index].hasSpecialDiscount) {
            newCart[r.index].specialDiscountRemark = "";
          }
        }
      }
      finalOrder.discount = discount;
      finalOrder.redeem = redeem;
      finalOrder.data = newCart;
      localStorage.setItem("order", JSON.stringify(newCart));
      localStorage.setItem("finalOrder", JSON.stringify(finalOrder));
      setRedeem(redeem);
      addToCart(newCart);
      setFinalOrder(finalOrder);
      setSubtotal(promo.subTotalAmount(newCart, discount));
    }
  }
  const handleAdvRewardRemove = (r, i) => {
    if (redeem[i].campaignId == r.campaignId) {
      redeem.splice(i, 1);
      if (r.index == -1) {
        if (discount && discount.furtherDiscount > 0) {
          discount.furtherDiscount = 0;
          discount.hasFurtherDiscount = false;
          discount.furtherDiscountRemark = "";
        } else if (discount) {
          discount.furtherDiscountAmount -= r.spendingAmount;
          if (discount.furtherDiscountAmount < 0) {
            discount.furtherDiscountAmount = 0;
          }
          discount.hasFurtherDiscount = Math.round(discount.furtherDiscountAmount * 100) > 0;
          if (!discount.hasFurtherDiscount) {
            discount.furtherDiscountRemark = "";
          }
        }
        setDiscount(discount);
        setSubtotal(promo.subTotalAmount(cart, discount));
      } else {
        if (cart[r.index].specialDiscount > 0) {
          cart[r.index].specialDiscount = 0;
          cart[r.index].hasSpecialDiscount = false;
          cart[r.index].specialDiscountRemark = "";
          cart[r.index].specialDiscountAmount = 0;
        } else {
          cart[r.index].specialDiscountAmount -= r.spendingAmount;
          cart[r.index].specialDiscount = 0;
          cart[r.index].hasSpecialDiscount = false;
          cart[r.index].hasSpecialDiscount = Math.round(cart[r.index].specialDiscountAmount * 100) > 0;
          if (!cart[r.index].hasSpecialDiscount) {
            cart[r.index].specialDiscountRemark = "";
          }
        }
      }

      finalOrder.redeem = redeem;
      finalOrder.data = cart;
      localStorage.setItem("finalOrder", JSON.stringify(finalOrder));
      setRedeem(redeem);
      addToCart(cart);
      setFinalOrder(finalOrder);
      setSubtotal(promo.subTotalAmount(cart, discount));
    }
  }
  // Checkout/address selection supplies the delivery quote. Preserve it here,
  // including a zero fee; reward changes must not replace it with a default rate.

  useEffect(() => {

    setDefaultAmount(promo.subTotalDefaultAmount(cart));
    setSubtotal(promo.subTotalAmount(cart, discount));
  }, [cart, discount]);

  useEffect(() => {
    const reserveData = readStoredJSON("reserveData");
    if (restored && finalOrder?.reserveId && reserveData?.reservationId === finalOrder.reserveId) {
      setReserveData(reserveData);
    }
  }, [setReserveData, restored, finalOrder?.reserveId]);

  useEffect(() => {
    if (!signature) return;
    ghlSubmit.current.click();
  }, [signature])

  useEffect(() => {
    if (!debiaFormData || !debiaFormData.gatewayUrl || !debiaFormData.signMsg) return;
    debiaSubmit.current.click();
  }, [debiaFormData]);

  let serviceAmt = ((!isTakeAway && !paymentData.shouldExcludeDI) ? paymentData.serviceCharge : ((isTakeAway && !paymentData.shouldExclude) ? paymentData.serviceCharge : 0));
  // Calculate the service charge before tax using the existing discount and takeaway rules.
  const amountBeforeTax = promo.getFinalAmount(
    cart, discount, serviceCharge, { ...tax, taxMode: 0, tax: 0 },
    paymentData, isTakeAway, deliveryType
  );
  const serviceChargeAmount = amountBeforeTax - subtotal - bcrsNo * 0.1;
  const taxAmount = finalAmount - amountBeforeTax;
  if (typeof lanIndex === 'undefined') {
    return <></>
  }

  return (
    <BackgroundColor themeContext={themeContext}>
      {isLoading ? (
        <OrderLoading />
      ) : (
        <React.Fragment>
          <PaymentFooter themeContext={themeContext}>
            <CheckoutButton type="button" disabled={!canSubmit} themeContext={themeContext} onClick={sendOrder}>
              <span>{language[lanIndex].checkout}</span>
              <strong>{canSubmit ? `${currencySymbol}${(deliveryPrice + finalAmount).toFixed(2)}` : 'Calculating total…'}</strong>
            </CheckoutButton>
          </PaymentFooter>
          <HeaderContainer
            themeContext={themeContext}
            headerHeight={themeContext.headerHeight}
          >
          </HeaderContainer>
          <ArrowContainer
            themeContext={themeContext}
            headerHeight={themeContext.headerHeight}
            onClick={handleBackToCheckout}
          >
            <Link
              to="/checkout"
              style={{ display: "grid", placeContent: "center" }}
              onClick={(event) => event.preventDefault()}
            >
              <IoIosArrowBack
                color={themeContext.checkOutArrow}
                size={themeContext.headerHeight}
              />
            </Link>
          </ArrowContainer>

          <MenuTitleContainer
            headerHeight={themeContext.headerHeight}
            themeContext={themeContext}
          >{language[lanIndex].confirmPayment}</MenuTitleContainer>

          <Buffer height={72} />
          <InfoCard themeContext={themeContext}>
            <OrderIdentity takeAwayId={finalOrder && finalOrder.takeAwayId} />
            {!isTakeAway && deliveryType == 4 &&
              <ReserveInfo />
            }
            {!isTakeAway && deliveryType !== 4 &&
              <TableInfo />
            }
            {isTakeAway && deliveryType == 0 &&
              <PickupInfo setShow={setShowTk} />
            }
            {isTakeAway && deliveryType == 2 &&
              <DeliveryInfo setShow={setShowTk} />
            }

          </InfoCard>
          {hasMember && memberRedeem &&
            <RedeemButton themeContext={themeContext} onClick={() => {
              if (customer && customer != null) {
                setDialog(true);
              } else {
                setShowMemberLogin(true);
              }
            }}>
              <IoGift fontSize={24} />
              <RedeemTxt>{language[lanIndex].redeemVoucher}</RedeemTxt>
            </RedeemButton>
          }

          {hasAdvocado && advocadoRedeem &&
            <RedeemButton themeContext={themeContext} onClick={() => {
              if (adCustomer && adCustomer != null) {
                setDialog(true);
              } else {
                setShowAdvocadoLogin(true);
              }
            }}>
              <IoGift fontSize={24} />
              <RedeemTxt>{language[lanIndex].redeemVoucher}</RedeemTxt>
            </RedeemButton>
          }
          <RedeemWrapper>
            {redeem && redeem.map((r, i) =>
              <RedeemContent key={i}>
                <RedeemIcon>
                  <TbDiscount2 fontSize={24} />
                </RedeemIcon>
                <RedeemTitle>
                  {r.name ? r.name : r.rewardTitle}
                </RedeemTitle>
                <RedeemRemove onClick={handleRewardRemove(r, i)}>
                  <IoTrashBinOutline fontSize={20} color={themeContext.fontAlert} />
                </RedeemRemove>
              </RedeemContent>
            )}
          </RedeemWrapper>
          <React.Fragment>
            {/* {cart.map((item, index) => {
              return (
                <CheckoutPanel
                  key={index + item.title + item.codeId}
                  cart={cart}
                  handleDelete={handleDelete}
                  handleAdd={handleAdd}
                  handleMinus={handleMinus}
                  handleItemClick={handleItemClick}
                  index={index}
                  item={item}
                  height={height}
                  width={width}
                  lanIndex={lanIndex}
                  currencySymbol={currencySymbol}
                  deleteActive={true}
                />
              );
            })} */}

            <Divider themeContext={themeContext} />
            <SubTotalWrapper themeContext={themeContext}>
              {hasVoucher && (advocadoRedeem || memberRedeem) &&
                //voucher promo area
                <SubtotalAndTaxContainer
                  themeContext={themeContext}
                  width={Math.min(550, width) - 40}
                >
                  <VoucherField />
                </SubtotalAndTaxContainer>
              }

              <SubtotalAndTaxContainer
                themeContext={themeContext}
                width={Math.min(550, width) - 40}
              >
                <LeftColumn>
                  {language[lanIndex].subtotal}
                </LeftColumn>
                <RightColumn>
                  {currencySymbol}&nbsp;{defaulAmount.toFixed(2)}
                </RightColumn>

              </SubtotalAndTaxContainer>
              {defaulAmount != subtotal && !(discount && discount.isAfterTax) &&
                <SubtotalAndTaxContainer
                  themeContext={themeContext}
                  width={Math.min(550, width) - 40}
                >

                  <LeftColumn>
                    {language[lanIndex].discount}
                  </LeftColumn>
                  <RightColumn>
                    {currencySymbol}&nbsp;{(subtotal - defaulAmount).toFixed(2)}
                  </RightColumn>

                </SubtotalAndTaxContainer>
              }
              {Math.round(serviceChargeAmount * 100) > 0 &&
                <SubtotalAndTaxContainer
                  themeContext={themeContext}
                  width={Math.min(550, width) - 40}
                >
                  <LeftColumn>
                    {language[lanIndex].serviceCharge}
                  </LeftColumn>
                  <RightColumn>
                    {currencySymbol}&nbsp;{serviceChargeAmount.toFixed(2)}
                  </RightColumn>
                </SubtotalAndTaxContainer>
              }
              {taxAmount > 0 && !(discount && discount.isAfterTax) &&
                <SubtotalAndTaxContainer
                  themeContext={themeContext}
                  width={Math.min(550, width) - 40}
                >
                  <LeftColumn>
                    {language[lanIndex].tax}
                  </LeftColumn>
                  <RightColumn>
                    {currencySymbol}&nbsp;{taxAmount.toFixed(2)}
                  </RightColumn>
                </SubtotalAndTaxContainer>
              }
              {taxAmount > 0 && discount && discount.isAfterTax &&
                <SubtotalAndTaxContainer
                  themeContext={themeContext}
                  width={Math.min(550, width) - 40}
                >
                  <LeftColumn>
                    {language[lanIndex].tax}
                  </LeftColumn>
                  <RightColumn>
                    {currencySymbol}&nbsp;{(defaulAmount * tax.tax).toFixed(2)}
                  </RightColumn>
                </SubtotalAndTaxContainer>
              }

              {defaulAmount != subtotal && discount && discount.isAfterTax &&
                <SubtotalAndTaxContainer
                  themeContext={themeContext}
                  width={Math.min(550, width) - 40}
                >
                  <LeftColumn>
                    {language[lanIndex].discount}
                  </LeftColumn>
                  <RightColumn>
                    {currencySymbol}&nbsp;{((subtotal - defaulAmount) * (1 + tax.tax)).toFixed(2)}
                  </RightColumn>
                </SubtotalAndTaxContainer>
              }

              {deliveryType == 2 &&
                <SubtotalAndTaxContainer
                  themeContext={themeContext}
                  width={Math.min(550, width) - 40}
                >
                  <LeftColumn>
                    {language[lanIndex].deliveryFee}
                  </LeftColumn>
                  <RightColumn>
                    {currencySymbol}&nbsp;{deliveryPrice.toFixed(2)}
                  </RightColumn>
                </SubtotalAndTaxContainer>}

              {bcrsNo > 0 &&
                <SubtotalAndTaxContainer
                  themeContext={themeContext}
                  width={Math.min(550, width) - 40}
                >
                  <LeftColumn>
                    BCRS
                  </LeftColumn>
                  <RightColumn>
                    {currencySymbol}&nbsp;{(bcrsNo * 0.1).toFixed(2)}
                  </RightColumn>
                </SubtotalAndTaxContainer>}

              <TotalContainer themeContext={themeContext} width={Math.min(550, width) - 40}>
                <LeftColumn>
                  {language[lanIndex].total}
                </LeftColumn>
                <RightColumn>
                  {currencySymbol}&nbsp;{((deliveryPrice + finalAmount)).toFixed(2)}
                </RightColumn>
              </TotalContainer>
            </SubTotalWrapper>
          </React.Fragment>
          <Buffer height={100} />
        </React.Fragment>
      )}
      <form name="payFormCcard" method="post" action="
        https://test.paydollar.com/b2cDemo/eng/payment/payForm.jsp">
        <input type="hidden" name="merchantId" value="12108712" />
        <input type="hidden" name="amount" value={(deliveryPrice + finalAmount).toFixed(2)} />
        <input type="hidden" name="orderRef" value="123" ref={orderRef} />
        <input type="hidden" name="currCode" value="702" />
        <input type="hidden" name="mpsMode" value="NIL" />
        <input type="hidden" name="successUrl"
          value="https://selforder.ireachfnb.com/payment/success" />
        <input type="hidden" name="failUrl" value="https://selforder.ireachfnb.com/payment/fail" />
        <input type="hidden" name="cancelUrl"
          value="https://selforder.ireachfnb.com/payment/cancel" />
        <input type="hidden" name="payType" value="N" />
        <input type="hidden" name="lang" value="E" />
        <input type="hidden" name="payMethod" value="ALL" />
        <input type="hidden" name="secureHash" value="" />
        <input type="hidden" name="remark" value={company.shortName} />
        <input type="submit" name="submit" style={{ display: "none" }} ref={asiaPaySubmit} />
      </form>
      <form method="post" action="https://pay.adaptispay.com/entry/adaptishosted">
        <input type="hidden" name="MerchantCode" value={merchantCode} />
        <input type="hidden" name="RefNo" value={finalOrder ? finalOrder.orderId : ""} />
        <input type="hidden" name="RequestType" value="10" />

        <input type="hidden" name="Language" value="ISO-8859-1" />
        <input type="hidden" name="Amount" value={(finalAmount + deliveryPrice).toFixed(2)} />
        <input type="hidden" name="Currency" value="MYR" />
        <input type="hidden" name="ProdDesc" value="FNB Sales" />
        <input type="hidden" name="Name" value="Walk In" />
        <input type="hidden" name="Email" value="admin@eightpos.com" />
        <input type="hidden" name="ContactNumber" value="0123456789" />

        <input type="hidden" name="BillingAddressLine1" value="-" />
        <input type="hidden" name="BillingAddressState" value="-" />
        <input type="hidden" name="BillingAddressCity" value="-" />
        <input type="hidden" name="BillingAddressPostalCode" value="000000" />
        <input type="hidden" name="BillingAddressCountry" value="Malaysia" />

        <input type="hidden" name="SignatureType" value="HMACSHA512" />
        <input type="hidden" name="Signature" value={signature} />

        <input type="hidden" name="ResponseURL" value={`https://selforder.ireachfnb.com/v2/api/ghl/check/${company._id}/${finalOrder ? finalOrder.orderId : ''}`} />
        <input type="hidden" name="BackendURL" value="https://selforder.ireachfnb.com/v2/api/ghl/callback" />

        <input type="submit" name="submit" style={{ display: "none" }} ref={ghlSubmit} />
      </form>
      <form method="post" action={debiaFormData ? debiaFormData.gatewayUrl : ""}>
        {debiaFormData && Object.keys(debiaFormData)
          .filter((key) => key !== "gatewayUrl" && key !== "method" && debiaFormData[key] !== null && debiaFormData[key] !== undefined)
          .map((key) => (
            <input type="hidden" name={key} value={debiaFormData[key]} key={key} />
          ))}
        <input type="submit" style={{ display: "none" }} ref={debiaSubmit} />
      </form>
      <Modal show={show} setShow={setShow} error={error} />
      {showTk &&
        <TakeAwayModal
          show={showTk}
          setShowTk={setShowTk}
          deliveryType={deliveryType}
          confirmTKCheckOut={confirmTKCheckOut}
          lanIndex={lanIndex}
          ph={finalOrder.phone}
          nm={finalOrder.customerName}
          dt={finalOrder.scheduleTime ? moment(finalOrder.scheduleTime).format("YYYY-MM-DD HH:mm") + " - " + moment(finalOrder.scheduleTime).add(30, "minute").format("HH:mm") : ""}
          addr={finalOrder.addressLine ?? finalOrder.address}
          postalValue={finalOrder.postal}
          unitValue={finalOrder.unit}
          rm={finalOrder.roomNo}
          remarkValue={finalOrder.remark}
          selectedCheckboxs={finalOrder.checkbox}
          setDeliveryPrice={setDeliveryPrice}
          deliveryPrice={deliveryPrice}
          totalAmount={finalAmount}
          currencySymbol={currencySymbol}
        />
      }
      {showDialog && advocadoRedeem &&
        <AdvocadoRedeem show={showDialog} setShow={setDialog} />
      }
      {showAdvocadoLogin &&
        <AdvocadoLogin
          show={showAdvocadoLogin}
          setShow={setShowAdvocadoLogin}
          handleCallback={() => { setShowAdvocadoLogin(false); setDialog(true); }}
        />
      }

      {showDialog && memberRedeem &&
        <CustomerRedeem show={showDialog} setShow={setDialog} deliveryType={deliveryType} />
      }
      {showMemberLogin &&
        <CustomerLogin
          show={showMemberLogin}
          setShow={setShowMemberLogin}

          handleCallback={() => { setShowMemberLogin(false); setDialog(true); }}
        />

      }
    </BackgroundColor>
  );
};

export default Checkout;
const RedeemWrapper = styled.div`

`;
const RedeemIcon = styled.div`
  display: flex;
`;
const RedeemRemove = styled.div`
  padding: 8px;
`;
const RedeemTitle = styled.div`
  margin-left: 4px;
  flex-grow: 1;
  width: 100%;
`;
const RedeemContent = styled.div`
  display: flex;
  align-items: center;
  margin: 0 16px;
  margin-top: 4px;
  padding: 8px 0px;
  border-top: 1px solid #e3e3e3;
`;
const RedeemTxt = styled.div`
  margin-left: 4px;
`;
const RedeemButton = styled.button`
  margin: 16px; width: calc(100% - 32px); box-sizing: border-box; min-height: 48px;
  border: 1px solid ${p => lightTint(p.themeContext.primaryColor, .25)};
  border-radius: 14px; padding: 12px; display: flex; align-items: center; justify-content: center;
  background: ${p => lightTint(p.themeContext.primaryColor, .07)};
  color: ${p => readableText(lightTint(p.themeContext.primaryColor, .07), p.themeContext.primaryColor)};
  font: inherit; font-size: 14px; cursor: pointer;
`;
const Divider = styled.div`
border-bottom: 1px solid ${(props) => props.themeContext.borderColor};
height: 1px;
margin: 16px 16px;
`;
//Styled Components
const BackgroundColor = styled.div`
  height: 100vh;
  min-height: 100dvh; height: 100dvh; width: 100vw; max-width: 550px;
  box-sizing: border-box;
  margin: 0 auto; overflow-y: auto;
  background: ${p => p.themeContext.backgroundColor};
  color: ${p => readableText(p.themeContext.backgroundColor, p.themeContext.fontPrimary)};
  font-family: ${p => p.themeContext.fontFamily};
`;

const HeaderContainer = styled.div`
  position: fixed; top: 0; width: 100%; max-width: 550px; height: 60px;
  background: ${p => p.themeContext.secondaryColor};
  border-bottom: 1px solid ${p => lightTint(p.themeContext.primaryColor, .18)}; z-index: 5;
`;

const ArrowContainer = styled.div`
  position: fixed; top: 0; z-index: 10; width: 52px; height: 60px; display: grid; place-items: center; cursor: pointer;
`;

const CheckoutButton = styled.button`
  display: flex; align-items: center; justify-content: space-between; gap: 16px;
  width: 100%; box-sizing: border-box; min-height: 48px; padding: 12px 20px; border: 0; border-radius: 999px;
  background: ${p => p.themeContext.primaryColor};
  color: ${p => actionTextColor(p.themeContext)};
  font: inherit; font-size: 14px; font-weight: 600; cursor: pointer;
  &:focus-visible { outline: 2px solid currentColor; outline-offset: -5px; }
`;


const MenuTitleContainer = styled.div`
  position: fixed; top: 0; margin-left: 56px; height: 60px; display: flex; align-items: center;
  font-size: 16px; font-weight: 600; z-index: 5;
  color: ${p => p.themeContext.checkOutArrow};
`;

const Buffer = styled.div`
  display: block;
  height: ${(props) => props.height}px;
`;

const SubTotalWrapper = styled.div`
  margin: 16px; padding: 16px; border-radius: 16px;
  border: 1px solid ${p => lightTint(p.themeContext.primaryColor, .16)};
  background: ${p => lightTint(p.themeContext.primaryColor, .035)};
`;

const SubtotalAndTaxContainer = styled.div`
  display: flex; justify-content: space-between; gap: 16px; width: 100%; box-sizing: border-box;
  color: ${p => readableText(lightTint(p.themeContext.primaryColor, .035), p.themeContext.fontPrimary)};
  font-size: 13px; line-height: 1.5; padding-bottom: 10px;
`;

const LeftColumn = styled.div`
  flex-grow: 1;
`;

const RightColumn = styled.div`
  text-align: right;
`;

const TotalContainer = styled.div`
  display: flex; justify-content: space-between; gap: 16px; width: 100%; padding-top: 14px; margin-top: 4px;
  border-top: 1px solid ${p => lightTint(p.themeContext.primaryColor, .2)};
  color: ${p => readableText(lightTint(p.themeContext.primaryColor, .035), p.themeContext.fontPrimary)};
  font-size: 17px; font-weight: 700;
`;

const PaymentFooter = styled.div`
  position: fixed; bottom: 0; left: 50%; transform: translateX(-50%);
  width: 100%; max-width: 550px; box-sizing: border-box;
  padding: 12px 16px max(12px, env(safe-area-inset-bottom)); z-index: 12;
  background: ${p => p.themeContext.backgroundColor};
  border-top: 1px solid ${p => lightTint(p.themeContext.primaryColor, .18)};
`;
const InfoCard = styled.div`
  margin: 0 16px;
  > div:first-child { margin: 0 0 16px; }
  > div { border-radius: 14px; }
  > div > div { border-color: ${p => lightTint(p.themeContext.primaryColor, .2)}; }
`;
